export default {
    URL: 'https://testcab.sah.md',
    auth:{
        service:["form","facebook","google"],
        registration:true,
        required:["last_name","email"],
        show_forget_password_button:false
    },
    zdjUrl: 'https://zdj.sah.md/',
    default_locale:"ro",
    languages_supported:["ru","en","ro"],
    yandex:{
        verification_key:"bee3b70284d78b1a"
    },
    homepage:'https://sah.md',
widget_endpoint:"https://sky.s20.online/common/1/online-schedule?branch=1&locale=ro&pc=e74c3d&crm=https://sky.s20.online&token=4a196a6e256ca03f3af576f3b6c357cb&appKey=c243a5814372a15dfe2d72fed485a01b&lead_status=1&lead_source=3&"
}

